import React from "react";
import { Album } from "../../types/Album";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { format, getLetter } from "../../components/text-helper/text-helper";
import HighlightedText from "./HighlightedText";
import "./Search.scss";

interface AlbumSearchResultProps {
    index: number;
    searchText: string;
    album: Album;
}

const AlbumSearchResult = (props: AlbumSearchResultProps) => {
    return (
        <Box component={Link}
            className="search-result"
            key={`$album-${props.index}`}
            to={`/letters/${getLetter(props.album.artistName)}/artists/${props.album.artistName}/albums/${props.album.year} - ${props.album.title}`}
        >
            <HighlightedText searchText={props.searchText} term={props.album.title} />
            by {format(props.album.artistName)} ({props.album.year})
        </Box>
    );
}

export default AlbumSearchResult;